import { DrawerObject } from '@/components/drawer/drawer.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicForm } from '@/components/form-builder/form-builder.types';

interface IModeEvaluationFinalDrawerObjectProps {
  formObject: DynamicForm;
  toggleVisibility?: () => void;
  action?: () => void;
}

export const modeEvaluationFinalDrawerObject = ({ formObject, toggleVisibility, action }: IModeEvaluationFinalDrawerObjectProps): DrawerObject => {
  return {
    title: 'settings.dacScenarios.edit.modeEvaluationFinal.title',
    description: 'settings.dacScenarios.edit.modeEvaluationFinal.description',
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject,
      },
    },
    actions: [
      {
        label: 'settings.dacScenarios.edit.add', // "Enregistrer" (Save)
        onClick: () => action?.(),
      },
      {
        label: 'settings.dacScenarios.edit.cancel',
        onClick: () => {
          toggleVisibility?.();
        },
        variant: 'secondary',
      },
    ],
  };
};
